module.exports = __webpack_public_path__ + "core-img/loader.5a474bcbd8d2f2826f03d10ea44bf60e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/images/loader.gif
// module id = 109
// module chunks = 0